import React from 'react'
import FinanceStatusBadge from '../FinanceStatusBadge'
import FinanceCard from '../foundation/FinanceCard'
import FinanceInfoGrid from '../foundation/FinanceInfoGrid'
import FinanceInfoItem from '../foundation/FinanceInfoItem'
import { FinanceInfoField } from '../types'

interface Props {
  title: React.ReactNode
  status?: React.ReactNode
  fields: FinanceInfoField[]
  footer?: React.ReactNode
}

const FinanceDocumentSummary: React.FC<Props> = ({
  title,
  status,
  fields,
  footer,
}) => {
  const allFields = status
    ? [{ label: 'Status', value: status, emphasis: false }, ...fields]
    : fields

  return (
    <FinanceCard title={title}>
      <FinanceInfoGrid $columns={3}>
        {allFields.map((field, index) => (
          <FinanceInfoItem
            key={`${String(field.label)}-${index}`}
            label={field.label}
            value={field.value}
            emphasis={field.emphasis}
          />
        ))}
      </FinanceInfoGrid>
      {footer}
    </FinanceCard>
  )
}

export const asStatusNode = (status?: string | null) => (
  <FinanceStatusBadge status={status || '--'} />
)

export default FinanceDocumentSummary
